/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import MessageRepository from '../../repositories/Admin/MessageRepository';
import { createRestSlice } from '../../utils/RestSlice';

const messagesRestSlice = createRestSlice({
  resource: 'message',
  repository: MessageRepository,
  slices: ['loadMessages'],
});

const initialState = {
  ...messagesRestSlice.initialState,
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    ...messagesRestSlice.reducers,
  },
});

export default messagesSlice.reducer;

export const messagesRestHooks = messagesRestSlice.hooks(messagesSlice, [
  'admin',
  'MessagesSlice',
]);
